import React, { useState, useEffect, useCallback } from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '100%'
};

// Default center (New Delhi, India)
const defaultCenter = {
    lat: 28.6139,
    lng: 77.2090
};

const libraries = ['places']; // Load 'places' library for future Autocomplete use

export default function LocationMap({ lat, lng, onChange }) {
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: libraries
    });

    const [map, setMap] = React.useState(null);
    const [position, setPosition] = useState(defaultCenter);

    // Parse props to numbers
    const latNum = parseFloat(lat);
    const lngNum = parseFloat(lng);
    const isValid = !isNaN(latNum) && !isNaN(lngNum);

    useEffect(() => {
        if (isValid) {
            const newPos = { lat: latNum, lng: lngNum };
            setPosition(newPos);
            if (map) {
                map.panTo(newPos);
            }
        }
    }, [latNum, lngNum, isValid, map]);

    const onLoad = useCallback(function callback(map) {
        // If invalid start, set bounds or just stay at default
        setMap(map);
    }, []);

    const onUnmount = useCallback(function callback(map) {
        setMap(null);
    }, []);

    const onDragEnd = useCallback((e) => {
        if (onChange) {
            onChange(e.latLng.lat(), e.latLng.lng());
        }
    }, [onChange]);

    if (loadError) {
        return <div>Error loading maps</div>;
    }

    if (!isLoaded) {
        return <div>Loading Map...</div>;
    }

    return (
        <div style={{ height: '300px', width: '100%', marginBottom: '1rem', borderRadius: '8px', overflow: 'hidden' }}>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={position}
                zoom={isValid ? 15 : 10}
                onLoad={onLoad}
                onUnmount={onUnmount}
                onClick={(e) => {
                    // Allow clicking map to move marker too
                    if (onChange) onChange(e.latLng.lat(), e.latLng.lng());
                }}
            >
                <Marker
                    position={position}
                    draggable={true}
                    onDragEnd={onDragEnd}
                />
            </GoogleMap>
        </div>
    );
}
